import { $api } from "services/AxiosInstance";

/**
 * PSN-3416: налаштування GA4 Measurement Protocol (Settings → GA4 settings) і журнал покупок
 * (Analytics → GA4 purchases), шляхи як у seller-engine.
 *
 * @typedef {Object} GA4Config
 * @property {boolean} ga4_enabled
 * @property {boolean} ga4_is_prod
 * @property {string} ga4_api_secret_stage
 * @property {string} ga4_measurement_id_stage
 * @property {string} ga4_api_secret_prod
 * @property {string} ga4_measurement_id_prod
 *
 * @typedef {Object} QueryPurchasesRequest
 * @property {number} [page]
 * @property {number} [size]
 * @property {Array<{key: string, value: string}>} [sort]
 * @property {Array<{key: string, value: *, regex?: boolean}>} [search]
 * @property {string} [filterCreatedDateStart] ISO, UTC
 * @property {string} [filterCreatedDateEnd] ISO, UTC
 * @property {string} [userId] id кабінету, точний збіг
 * @property {string} [email] точний збіг без урахування регістру
 */
export class GTMService {
  /** @returns {Promise<{data: GA4Config}>} */
  static getConfig() {
    return $api.get("/api/admin/v1/ga4/v1/config");
  }

  /** @param {GA4Config} params */
  static saveConfig(params) {
    return $api.post("/api/admin/v1/ga4/v1/config/save", params);
  }

  /**
   * Сторінка журналу + totalAmount за фільтрами
   * @param {QueryPurchasesRequest} body
   */
  static queryPurchases(body) {
    return $api.post("/api/admin/v1/ga4/v1/purchases/query", body);
  }

  /**
   * CSV за фільтрами таблиці (без page/size)
   * @param {QueryPurchasesRequest} body
   */
  static exportPurchases(body) {
    return $api.post("/api/admin/v1/ga4/v1/purchases/export", body, { responseType: "blob" });
  }

  static getPurchaseById(id) {
    return $api.get(`/api/admin/v1/ga4/v1/purchases/byId?id=${encodeURIComponent(id)}`);
  }
}
